import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=b9c216ae&scoped=true&"
import script from "./CustomerNew.vue?vue&type=script&lang=ts&"
export * from "./CustomerNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c216ae",
  null
  
)

export default component.exports